import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

/* Build CSS */
import './App.css';

/* Build Components */
import { Header } from "./Components/Header";
import { Home } from './Routes/Home';
import { About } from './Routes/About';
import { Portfolio } from './Routes/Portfolio';
import { Contact } from './Routes/Contact';
import { Resume } from './Routes/Resume';
import { Blogs } from "./Routes/Blogs";


function App() {
  return (
    <div className="App c-basic">
      <Router>
        <Header/>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
